import React, { Component } from "react";
import PropTypes from "prop-types";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import ViewHeadline from "@material-ui/icons/ViewHeadline";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Tasks from "components/Tasks/Tasks.jsx";
import Articles from "components/Articles/Articles.jsx";
import {EditArticleLightbox} from "components/Articles/Articles.jsx";
import {SendArticleLightbox} from "components/Articles/Articles.jsx";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import Danger from "components/Typography/Danger.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import Slider from "components/Slider/Slider.jsx";
import Typography from '@material-ui/core/Typography';
import Catalog from "views/Catalog/Catalog.jsx";

// import { bugs, website, server } from "variables/general.jsx";
import { doAjax, doAjaxPost, getSettingValue, getSettingValueAsBoolean } from "variables/common.js";
import * as constants from "variables/constants.jsx";

import Moment from 'react-moment';


import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import i18next from 'i18next';

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart
} from "variables/charts.jsx";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

//const ReactHighcharts = require('react-highcharts');

window.Highcharts = Highcharts;

function WidgetNews(props) {

	return (
		<>
		<GridItem xs={12} sm={12} md={12}>
          
			<EditArticleLightbox isAdmin={props.isAdmin} isManager={props.isManager} i18n={props.i18n} innerRef={props.editArticleLBRef} handleProgressBarOpen={props.handleProgressBarOpen} 
          							type={props.state.articlesTabActiveId} handleProgressBarClose={props.handleProgressBarClose} 
          							handleShowSnackbar={props.handleShowSnackbar} onClose={() => {props.loadArticles(1); props.loadArticles(2); props.loadArticles(3);}} />

			<SendArticleLightbox isAdmin={props.isAdmin} isManager={props.isManager} i18n={props.i18n} innerRef={props.sendArticleLBRef} handleProgressBarOpen={props.handleProgressBarOpen} 
          							type={props.state.articlesTabActiveId} handleClose={props.handleSendLBClose} handleProgressBarClose={props.handleProgressBarClose} 
          							handleShowSnackbar={props.handleShowSnackbar} onClose={() => {props.loadArticles(1); props.loadArticles(2); props.loadArticles(3);}} />
         	
            <CustomTabs
              headerColor="info"
              isAdmin={props.isAdmin}
              isManager={props.isManager}
			  i18n={props.i18n}
	          getTabActiveId={props.getArticlesTabActiveId} 
			  addClick={() => {if (props.editArticleLBRef && props.editArticleLBRef.current) { props.editArticleLBRef.current.handleOpen();} props.this.setState({ state: props.state }); }}
			  sendClick={() => {if (props.sendArticleLBRef && props.sendArticleLBRef.current) { props.sendArticleLBRef.current.handleOpen();} props.this.setState({ state: props.state }); }}
			  handleProgressBarOpen={props.handleProgressBarOpen}
			  handleProgressBarClose={props.handleProgressBarClose}
			  handleShowSnackbar={props.handleShowSnackbar}
			  tabs={[
				  ((props.state.actions.length > 0 || props.isAdmin) && {
                  tabName: props.i18n.t('actions'),
                  tabIcon: ViewHeadline,
                  tabId: 2,
                  tabContent: (
                    <Articles
                      articles={props.state.actions}
                      isAdmin={props.isAdmin}
                      isManager={props.isManager}
                      i18n={props.i18n}
                      editClick={props.editArticleLBRef && props.editArticleLBRef.current ? props.editArticleLBRef.current.handleOpen : null}
					    sendClick={props.sendArticleLBRef && props.sendArticleLBRef.current ? props.sendArticleLBRef.current.handleOpen : null}
                      handleProgressBarOpen={props.handleProgressBarOpen}
			  		  handleProgressBarClose={props.handleProgressBarClose}
			  		  handleShowSnackbar={props.handleShowSnackbar}
			  		  onDelete={() => props.loadArticles(2)}
	                  type={2}
                    />
                  )
                }),
                                
                               
                {
                  tabName: props.i18n.t('News'),
                  tabIcon: ViewHeadline,
                  tabId: 1,
                  tabContent: (
                    <Articles
                      articles={props.state.news}
                      isAdmin={props.isAdmin}
                      isManager={props.isManager}
                      i18n={props.i18n}
                      editClick={props.editArticleLBRef && props.editArticleLBRef.current ? props.editArticleLBRef.current.handleOpen : null}
					                      sendClick={props.sendArticleLBRef && props.sendArticleLBRef.current ? props.sendArticleLBRef.current.handleOpen : null}
			                      handleProgressBarOpen={props.handleProgressBarOpen}
			  		  handleProgressBarClose={props.handleProgressBarClose}
			  		  handleShowSnackbar={props.handleShowSnackbar}
			  		  onDelete={() => props.loadArticles(1)}
	                  type={1}
                    />
                  )
                },
                /*
                {
                  tabName: i18n.t('sales'),
                  tabIcon: Code,
                  tabContent: (
                    <Articles
                      
                      isAdmin={isAdmin}
                      isManager={isManager}
                      i18n={i18n}
                    />
                  )
                },
                
                {
                  tabName: i18n.t('discounts'),
                  tabIcon: Cloud,
                  tabContent: (
                    <Articles
                      articles={props.state.news}
                      isAdmin={props.isAdmin}
                      isManager={props.isManager}
                      i18n={props.i18n}
                    />
                  )
                } */
              ]}
            />
          </GridItem>
		</>
	
	);

}

function WidgetsRow1(props) {
  
  var classes = props.classes;
  var i18n = props.i18n;
  var makeCountOptions = props.makeCountOptions;
  
  return (
  		<>
		<GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader className={classes.chart} color="gray">
                <h4 className={classes.cardTitle}>{i18n.t("ordersCountByDays")}</h4>
              </CardHeader>
              <CardBody>
                <HighchartsReact options={props.makeCountOptions(props.state.ordersCountData)} allowChartUpdate = { true } highcharts={Highcharts} constructorType={'chart'} />
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <Card chart>
              <CardHeader className={classes.chart} color="gray">
                <h4 className={classes.cardTitle}>{i18n.t("orderItemsCountByDays")}</h4>
              </CardHeader>
              <CardBody>
               <HighchartsReact options={props.makeCountOptions(props.state.orderItemsCountData)} allowChartUpdate = { true } highcharts={Highcharts} constructorType={'chart'} />
              </CardBody>
            </Card>
          </GridItem>
		</>
	);
}
  
class Dashboard extends React.Component {

  constructor(props) {
    super(props);
    this.editArticleLBRef = React.createRef();
	    this.sendArticleLBRef = React.createRef();

    this.state = {
	    value: 0,
	    ordersCountData: [],
	    orderItemsCountData: [],
	    supplierClient: (localStorage.getItem('supplierClient') ? JSON.parse(localStorage.getItem('supplierClient')) : JSON.parse(localStorage.getItem('supplierUser')).value.supplierClient),
	    showCreditWidget: getSettingValueAsBoolean('DASHBOARD_SHOW_CREDIT_WIDGET', true),
	    showClientOrdersDebtWidget: getSettingValueAsBoolean('DASHBOARD_SHOW_CLIENT_ORDERS_DEBT_WIDGET', false),
	    news: [],
    	actions: [],
    	sliderImages: [],
    	clientOrdersDebt: [],
    	welcomeText: null
    };
    
    this.state.articlesTabActiveId = 0;

  }

  componentWillMount = () => {
    this.getSupplierClient();
    this.loadWelcomeText();
    this.loadArticles(1);
    this.loadArticles(2);
    this.loadArticles(3);
	Highcharts.setOptions({
      lang: {
        resetZoom: this.props.i18n.t('resetZoom'),
        resetZoomTitle: this.props.i18n.t('resetZoomValue')
      }
		    });
  }
  
  loadArticles = (type) => {
  	  var user = JSON.parse(localStorage.getItem('user')).value;
	  
	  var that = this;
	  
	  var cb = function(data) { 
		
	  switch (type) {
        case 1:
        that.state.news = data;
        break;
        case 2:
        that.state.actions = data;
        break;
        case 3:
        that.state.sliderImages = data;
        that.setState({ state: that.state });
        break;
       }
	    
	  };
	  
	  //key=' + constants.apiKey + '&supplierId=' + this.props.supplierId + "&principalId=" + user.id + "
	  // + '&upd=' + new Date().getTime()
	  var url = constants.apiBaseUrl + '/b2b/supplier/articles?&limit=';
          url +=  (type === 1  ? getSettingValue("B2B_NEWS_LIMIT", "3")  : getSettingValue("B2B_ACTIONS_LIMIT", "3") );
          url +=  '&type=' + type;
	  doAjax(url, cb, this.props.handleProgressBarClose);
  
  }
  
  loadWelcomeText = () => {
  
      var user = JSON.parse(localStorage.getItem('user')).value;
	
	  var that = this;
	  
	  var cb = function(data) { 
	    
	    // var welcomeDiv = document.getElementById('welcome-text');
	    // welcomeDiv && 
	    if (data) {
	    	// welcomeDiv.innerHTML
	    	// .replace(/(?:\r\n|\r|\n)/g, '<br>')
	    	that.state.welcomeText =  data.replace(/(?:\r\n|\r|\n)/g, '<br>');
	    	// document.getElementById('welcome-block').style.display = 'block';
	    	// that.setState({ state: that.state });
	    	// alert(that.state.welcomeText);
	    } else {
	    	
	    }
	    
	  };
	  
	  //key=' + constants.apiKey + '&supplierId=' + this.props.supplierId + "&principalId=" + user.id + '&upd=' + new Date().getTime()
	  var url = constants.apiBaseUrl + '/b2b/supplier/setting/welcome_text?';
	  doAjax(url, cb, this.props.handleProgressBarClose);
  
  }
  
  getSupplierClient = () => {
  
  	if (this.state.supplierClient) {
  	
  	  	var user = JSON.parse(localStorage.getItem('user')).value;
  	
  		//key=' + constants.apiKey + "&principalId=" + user.id + '&upd=' + new Date().getTime()
  		var url = constants.apiBaseUrl + '/b2b/supplier/client?' + "&supplierClientId=" + this.state.supplierClient.id;

	    var that = this;
	
	    var cb = function(data) { 
	    
	    	that.setState({supplierClient: data}); localStorage.setItem('supplierClient', JSON.stringify(data));
	        
	        that.getOrdersCountData();
    		that.getOrderItemsCountData();
    		
    		that.getClientOrdersDebt();
	    
	     };
	
	    this.props.handleProgressBarOpen();
	    doAjax(url, cb, this.props.handleProgressBarClose);
  	
  	} else {
  		
  		this.getOrdersCountData();
    	this.getOrderItemsCountData();
  		
  	}
  
  
  }

  getOrdersCountData = () => {
  
    var user = JSON.parse(localStorage.getItem('user')).value;
  
  	//key=' + constants.apiKey + "
  	//&principalId=" + user.id + '&upd=' + new Date().getTime() + "&supplierId=" + this.props.supplierId
    var url = constants.apiBaseUrl + '/b2b/supplier/orders-by-dates?&days=999999';
    if (this.state.supplierClient) {
    	url += "&supplierClientId=" + this.state.supplierClient.id;	
    }
      
    // + (!this.props.isAdmin ? "&userId=" + this.props.userId : "");

    var that = this;

    var cb = function(data) { that.setState({ordersCountData: data}); };

    // this.props.handleProgressBarOpen();
    doAjax(url, cb); // , this.props.handleProgressBarClose
  }

  getOrderItemsCountData = () => {
   
    var user = JSON.parse(localStorage.getItem('user')).value;
  
  	//key=' + constants.apiKey + "&principalId=" + user.id + '&upd=' + new Date().getTime() + "&supplierId=" + this.props.supplierId
    var url = constants.apiBaseUrl + '/b2b/supplier/order-items-by-dates?';
	if (this.state.supplierClient) {
    	url += "&supplierClientId=" + this.state.supplierClient.id;	
    }
	// + (!this.props.isAdmin ? "&userId=" + this.props.userId : "")

    var that = this;

    var cb = function(data) { that.setState({orderItemsCountData: data}); };

    // this.props.handleProgressBarOpen();
    doAjax(url, cb); //, this.props.handleProgressBarClose
  }
  
  getClientOrdersDebt = () => {
   
    var user = JSON.parse(localStorage.getItem('user')).value;
  
  	//key=' + constants.apiKey + "&principalId=" + user.id + '&upd=' + new Date().getTime() + "&supplierId=" + this.props.supplierId
    var url = constants.apiBaseUrl + '/b2b/supplier/client/debt/orders?';
  	url += "&supplierClientId=" + this.state.supplierClient.id;	

    var that = this;

    var cb = function(data) { that.setState({clientOrdersDebt: data}); };

    // this.props.handleProgressBarOpen();
    doAjax(url, cb); // , this.props.handleProgressBarClose
  }

  getDates = (list, type) => {
    var dates = [];
    var formatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    if (type) {
    	switch (type) {
	    	case 'months':
		    	formatOptions = { month: '2-digit', year: 'numeric' };
    	break;
    	}
    }

    list.map(row => {
      var spl = row[0].split('.');
      dates.push(new Date(spl[0], spl[1] - 1, (spl.length > 2 ? spl[2] : 1)).toLocaleDateString('ru-RU', formatOptions));
    });

    return dates;
  }

  getSeries = (list, type) => {
    var series = [{ data: []}];
    var formatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    if (type) {
    	switch (type) {
	    	case 'months':
		    	formatOptions = { month: '2-digit', year: 'numeric' };
    	break;
    	}
    }

    series[0].name = this.props.i18n.t('qty');
    list.map(row => {
      series[0].data.push(parseInt(row[1]));
    });
    
    return series;
  }

  makeCountOptions = (list, type) => {
    return {
      chart: {
        zoomType: 'x',
        type : 'column',
        height: 300 ,
        animation: true
      },
      credits: {
        enabled: false
      },
      tooltip : {
        shared : true
      },
      title: '',
      dateRangeGrouping: {
        enabled: true,
        approximation: 'averages',
    	groupPixelWidth: 10,
    	forced: true,
                    units: [
                        ['month', [1]]
                    ],
        
      },
      
      dateRangeGrouping: {
        dayFormat: { month: 'numeric', day: 'numeric', year: 'numeric' }, weekFormat: 
                   { month: 'numeric', day: 'numeric', year: 'numeric' }, monthFormat: { month: 'numeric', year: 'numeric' }
    },
    
    legend : {
							enabled : true,
							maxHeight : 60
						},
    
      xAxis: {
        categories: this.getDates(list, type),
        labels: {
          rotation: -45
        },
        crosshair: {
          width: 1,
          color: '#c4c4c4'
        },
        type: "datetime"        
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      series: this.getSeries(list, type),
      exporting: {
        enabled: false
      }
    }
  }
  
  makeDebtChart = value => {
    return {
      chart: {
        zoomType: 'x',
        height: 300
      },
      credits: {
        enabled: false
      },
      tooltip : {
        shared : true
      },
      title: '',
      dateRangeGrouping: {
        enabled: true
      },
      xAxis: {
        labels: {
          rotation: -45
        },
        crosshair: {
          width: 1,
          color: '#c4c4c4'
        }
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      //series: this.getSeries(value),
      exporting: {
        enabled: false
      }
    }
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };
  getArticlesTabActiveId = (value) => {
    this.state.articlesTabActiveId = value;
  }
  
  render() {
    const { classes, i18n, isAdmin, isManager, handleProgressBarOpen, handleProgressBarClose } = this.props;
    
    //console.log(this.editArticleLBRef);
    
    return (
      <div>
		{window.location.href.indexOf('triovist') >= 0 || window.location.href.indexOf('localhost') >= 0 ?
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Catalog
              i18n={i18next}
              handleProgressBarOpen={this.props.handleProgressBarOpen}
              handleProgressBarClose={this.props.handleProgressBarClose}
              handleShowSnackbar={this.props.handleShowSnackbar}
              classes={classes}
              supplierId={this.props.supplierId}
              isAdmin={isAdmin}
              isClientAdmin={this.state.isClientAdmin}
              isSupervisor={this.state.isSupervisor}
              isWidget='true'
            />
          </GridItem>
        </GridContainer> : ""
        }
        {getSettingValueAsBoolean('DASHBOARD_SHOW_BANNERS_SLIDER', false) ?
	        <GridContainer>
	          <GridItem xs={12} sm={12} md={12}>
	          <Card chart>
	              <CardHeader className={classes.chart} color="gray">
	                <h4 className={classes.cardTitle}></h4>
	              </CardHeader>
	              <CardBody>
						<Slider
							images={this.state.sliderImages[0]}
							isAdmin={isAdmin} 
	          				isManager={isManager} 
	          				i18n={i18n} 
							editClick={this.editArticleLBRef && this.editArticleLBRef.current ? this.editArticleLBRef.current.handleOpen : null}
	          			/>
	          			<EditArticleLightbox 
	          				isAdmin={isAdmin} 
	          				isManager={isManager} 
	          				i18n={i18n} 
	          				innerRef={this.editArticleLBRef} 
	          				handleProgressBarOpen={this.props.handleProgressBarOpen} 
          					type={3} 
          					handleProgressBarClose={this.props.handleProgressBarClose} 
          					handleShowSnackbar={this.props.handleShowSnackbar} 
          					onClose={() => {this.loadArticles(3)}} 
          				/>
	              </CardBody>
	            </Card>
	            	
	          </GridItem>
	        </GridContainer> : ""
        }
        
        
        
        <GridContainer>
        
          <GridItem xs={12} sm={12} md={8}>
          
          <GridContainer>
        
          { getSettingValueAsBoolean('DASHBOARD_NEWS_ON_TOP', false) ? 
          		 (isAdmin || (this.state.news && this.state.news.length > 0)) &&
			          <WidgetNews i18n={i18n} isAdmin={isAdmin} isManager={isManager} state={this.state} editArticleLBRef={this.editArticleLBRef} sendArticleLBRef={this.sendArticleLBRef}
			          			  handleProgressBarOpen={this.props.handleProgressBarOpen} handleProgressBarClose={this.props.handleProgressBarClose}
			          			  handleShowSnackbar={this.props.handleShowSnackbar} getArticlesTabActiveId={this.getArticlesTabActiveId}
			          			  loadArticles={this.loadArticles} this={this}
			          />
          		 : 
          		 <WidgetsRow1 classes={classes} i18n={i18n} makeCountOptions={this.makeCountOptions} state={this.state} />
          }
          
          {(this.state.welcomeText) &&
		  <GridItem xs={12} sm={12} md={12}>
          	<Card>
              <CardBody>
              		<Typography id="welcome-text" variant="h4" style={{fontSize: "15px", lineHeight: "170%"}} dangerouslySetInnerHTML={{ __html: this.state.welcomeText }}>
              			
              		</Typography>
              </CardBody>
            </Card>
          </GridItem>
          }
        
        
        { getSettingValueAsBoolean('DASHBOARD_NEWS_ON_TOP', false) ? 
          <WidgetsRow1 classes={classes} i18n={i18n} makeCountOptions={this.makeCountOptions} state={this.state} />
          :
          (isAdmin || (this.state.news && this.state.news.length > 0)) &&
          <WidgetNews i18n={i18n} isAdmin={isAdmin} isManager={isManager} state={this.state} editArticleLBRef={this.editArticleLBRef} sendArticleLBRef={this.sendArticleLBRef}
          			  handleProgressBarOpen={this.props.handleProgressBarOpen} handleProgressBarClose={this.props.handleProgressBarClose}
          			  handleShowSnackbar={this.props.handleShowSnackbar} getArticlesTabActiveId={this.getArticlesTabActiveId}
          			  loadArticles={this.loadArticles} this={this}
          /> 
        }
        
        	</GridContainer>          
          
          </GridItem>
          
          <GridItem xs={12} sm={12} md={4}>
          
          	<GridContainer>
          
          {
         this.state.showCreditWidget && this.state.supplierClient && 
          <GridItem xs={12} sm={12} md={12}>
            <Card chart>
              <CardHeader className={classes.chart} color="gray">
                <h4 className={classes.cardTitle}>{i18n.t("Информация о кредите")}</h4>
              </CardHeader>
              <CardBody>
              	<Typography variant="h4" style={{fontSize: "15px", lineHeight: "170%"}}>
                	Использованный кредитный лимит: <b fontWeight="fontWeightBold">
                	{
                		(this.state.supplierClient.debtLimit == null && this.state.supplierClient.debt) > 0 ? 100 : 
                			(this.state.supplierClient.debtLimit != null ? 
                				Math.round((this.state.supplierClient.debt + (this.state.supplierClient.debtReserved != null ? this.state.supplierClient.debtReserved : 0)) / this.state.supplierClient.debtLimit * 100) 
                				: '')
                		}
                	%</b>
                </Typography>
              	<Typography variant="h4" style={{fontSize: "15px", lineHeight: "170%"}}>
                	Кредитный лимит: <b fontWeight="fontWeightBold">{this.state.supplierClient.debtLimit}</b>
                </Typography>
              	<Typography variant="h4" style={{fontSize: "15px", lineHeight: "170%"}}>
                	{getSettingValue("B2B_WIDGET_CREDIT_DEBT_TITLE", "Общая сумма долга")}: <b fontWeight="fontWeightBold">{this.state.supplierClient.debt}</b>
                </Typography>
              	<Typography variant="h4" style={{fontSize: "15px", lineHeight: "170%"}}>
                	Просроченная сумма долга: <b fontWeight="fontWeightBold">{this.state.supplierClient.debtOverdue}</b>
                </Typography>
                {this.state.supplierClient.debtReserved != null && 
	                <Typography variant="h4" style={{fontSize: "15px", lineHeight: "170%"}}>
	                	Сумма резервов по всем заказам: <b fontWeight="fontWeightBold">{this.state.supplierClient.debtReserved}</b>
	                </Typography>
                }
                {this.state.supplierClient.debtRemain != null && 
	                <Typography variant="h4" style={{fontSize: "15px", lineHeight: "170%"}}>
	                	Остаток лимита: <b fontWeight="fontWeightBold">{this.state.supplierClient.debtRemain}</b>
	                </Typography>
                }
                <br/>
                <span style={{color: "gray"}}>Последнее обновление:&nbsp;
                <Moment parse="DD.MM.YYYY HH:mm:ss" format="DD.MM.YYYY HH:mm">{this.state.supplierClient.dateUpd}
                </Moment>
                </span>
                
              </CardBody>
            </Card>
          </GridItem>
          }
          
          
          {
         this.state.showClientOrdersDebtWidget && this.state.supplierClient && 
          <GridItem xs={12} sm={12} md={12}>
            <Card chart>
              <CardHeader className={classes.chart} color="gray">
                <h4 className={classes.cardTitle}>{i18n.t("Информация о задолженностях")}</h4>
              </CardHeader>
              <CardBody>
              	<table className={classes.table} style={{width:'100%'}}>
              		<thead>
              			<th align={"left"}>ID Заказа</th>
              			<th align={"right"}>Номер заказа 1С</th>
              			<th align={"right"}>Дата платежа</th>
              			<th align={"right"}>Общая ДЗ</th>
              			<th align={"right"}>Просроченная ДЗ</th>
              		</thead>
              	{this.state.clientOrdersDebt && this.state.clientOrdersDebt.map((clientOrderDebt, index) => (
              		<tr>
              			{clientOrderDebt && clientOrderDebt.map((clientOrderDebtCol, colN) => (
              				<>
	              			{colN > 0 &&
	              				<td align={colN == 1 ? "left" : "right"}>{clientOrderDebtCol}</td>
	              			}
	              			</>
              			))}
              			
              		</tr>
              	))}
                </table>
              </CardBody>
            </Card>
          </GridItem>
          }
          
          	</GridContainer>
          
          </GridItem>
          
        </GridContainer>
        
          
        
        
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(dashboardStyle)(Dashboard);
